import React from "react";
import { TbChevronLeft, TbChevronRight } from "react-icons/tb";

import "../assets/styles/data-table.css";

export const getPaginationItems = (currentPage, totalPages) => {
  if (totalPages <= 7) {
    return Array.from({ length: totalPages }, (_, index) => index + 1);
  }

  const pages = [...new Set([
    1,
    totalPages,
    currentPage,
    currentPage - 1,
    currentPage + 1,
  ])]
    .filter((page) => page >= 1 && page <= totalPages)
    .sort((left, right) => left - right);

  return pages.flatMap((page, index) =>
    index > 0 && page - pages[index - 1] > 1
      ? [`ellipsis-${page}`, page]
      : [page]
  );
};

const TablePagination = ({
  page,
  totalPages,
  total,
  pageSize,
  onPageChange,
  onPageSizeChange,
  pageSizeOptions = [10, 25, 50],
  disabled = false,
  itemLabel = "items",
}) => {
  const lastPage = Math.max(1, Number(totalPages) || 1);
  const start = total === 0 ? 0 : (page - 1) * pageSize + 1;
  const end = Math.min(page * pageSize, total);

  return (
    <div className="dt-pagination">
      <div className="dt-pagination-info">
        <span>
          Showing <strong>{start}–{end}</strong> of{" "}
          <strong>{total}</strong> {itemLabel}
        </span>

        {onPageSizeChange && (
          <label>
            Rows
            <select
              value={pageSize}
              disabled={disabled}
              onChange={(event) =>
                onPageSizeChange(Number(event.target.value))
              }
            >
              {pageSizeOptions.map((option) => (
                <option key={option} value={option}>
                  {option}
                </option>
              ))}
            </select>
          </label>
        )}
      </div>

      <nav className="dt-pagination-nav" aria-label="Pagination">
        <button
          type="button"
          className="dt-page-step"
          disabled={disabled || page <= 1}
          onClick={() => onPageChange(page - 1)}
          aria-label="Previous page"
        >
          <TbChevronLeft />
          <span>Prev</span>
        </button>

        {getPaginationItems(page, lastPage).map((item) =>
          typeof item === "string" ? (
            <span key={item} className="dt-page-gap">
              …
            </span>
          ) : (
            <button
              type="button"
              key={item}
              className={`dt-page ${item === page ? "is-active" : ""}`}
              disabled={disabled}
              aria-label={`Go to page ${item}`}
              aria-current={item === page ? "page" : undefined}
              onClick={() => onPageChange(item)}
            >
              {item}
            </button>
          )
        )}

        <button
          type="button"
          className="dt-page-step"
          disabled={disabled || page >= lastPage}
          onClick={() => onPageChange(page + 1)}
          aria-label="Next page"
        >
          <span>Next</span>
          <TbChevronRight />
        </button>
      </nav>
    </div>
  );
};

export default TablePagination;
